import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ITopicWithTranslations } from 'src/app/core/models/i-topic-with-translations';
import { ISaveTopicRequest } from 'src/app/core/models/i-save-topic-request';
import { RestService } from 'src/app/shared/services/rest-service';

@Injectable({
  providedIn: 'root',
})
export class TopicService {
  static readonly ENTITY_IDENTIFIER: string = 'Topics';
  private readonly BASE_TOPIC_ROUTE = `api/${TopicService.ENTITY_IDENTIFIER}`;
  private readonly BUILD_HTTP_ROUTE = (...args) =>
    this.restService.BUILD_HTTP_ROUTE(this.BASE_TOPIC_ROUTE, ...args);

  constructor(private restService: RestService) {}

  getFiltered$(
    channels: string = null,
    searchText: string = null,
    pageSize: number = null,
    isFilter: boolean = null,
    ignoreParent: boolean = null,
  ): Observable<ITopicWithTranslations[]> {
    const params = this.restService.buildHttpParamsObject({
      searchText,
      channels,
      pageSize,
      isFilter,
      ignoreParent,
    });

    return this.restService.get$<ITopicWithTranslations[]>(this.BUILD_HTTP_ROUTE(), {
      params,
    });
  }

  getById$(id: number): Observable<ITopicWithTranslations> {
    return this.restService.get$<ITopicWithTranslations>(
      this.BUILD_HTTP_ROUTE(id.toString()),
    );
  }

  create$(request: ISaveTopicRequest): Observable<ITopicWithTranslations> {
    return this.restService.post$<ITopicWithTranslations>(
      this.BUILD_HTTP_ROUTE(),
      request,
    );
  }

  update$(
    id: number,
    request: ISaveTopicRequest,
  ): Observable<ITopicWithTranslations> {
    return this.restService.put$<ITopicWithTranslations>(
      this.BUILD_HTTP_ROUTE(id.toString()),
      request,
    );
  }

  delete$(id: number): Observable<unknown> {
    return this.restService.remove$(this.BUILD_HTTP_ROUTE(id.toString()));
  }
}
